import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import LandingPage from "@/pages/LandingPage";
import SeoPage from "@/pages/SeoPage";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/servicos" element={<SeoPage />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
